import React, { useEffect, useRef } from "react";
import BouncingDiv from "../BouncingDiv";
import Runningback from "../assets/videos/runningback.mp4";
import Runners from "../assets/images/marathon-runners-bw.gif";
import YMLogo from "../assets/YMLogo";
import { theme } from "../assets/theme";
import { useNavigate } from "react-router-dom";

export default function RunningbackPage() {
  const canvasRef = useRef();
  const videoRef = useRef();
  const navigate = useNavigate();

  return (
    <div
      id="bounce-container"
      className="flex h-[100dvh] min-w-[100dvw] flex-1 shrink-0  snap-center items-center justify-center"
      style={{
        backgroundColor: theme.main,
      }}
    >
      <canvas ref={canvasRef} className=" hidden  w-full" />
      <video
        autoPlay
        id="video-background"
        ref={videoRef}
        muted
        loop
        playsInline
        className="absolute top-0 flex h-full w-full object-cover"
        onLoad={() => {
          console.log("loaded");
        }}
      >
        <source src={Runningback} type="video/mp4" />
      </video>
      <div
        id="ContentContainer"
        className="relative flex h-[100vh] w-[100%] items-center rounded-md font-orbitron text-[10vw] font-[800]"
      >
        <div className="relative h-full w-full ">
          {/* <p className="absolute bottom-[15vh] right-0">RUNN!NG BACK</p> */}
          <div
            className="absolute bottom-[75px] right-0 z-[2] mr-[10px] flex cursor-pointer flex-col rounded-md p-[min(2vw,15px)] text-right text-[min(6vw,75px)] font-[900] text-[black]  blur-[0.5px] max-sm:text-[max(8vw,100%)]"
            style={{
              backgroundColor: theme.main,
            }}
            onClick={() => {
              navigate("videos?videoId=Runn!ngback");
            }}
          >
            <div className="relative flex flex-col items-center justify-center ">
              <img
                src={Runners}
                alt=""
                className="absolute z-[-1] h-full w-full opacity-[0.5] hue-rotate-60"
              />
              <p
                className="animate-slowRotate3d"
                style={{
                  textShadow: "3px 3px 5px white",
                }}
              >
                Runn!ngback
              </p>
            </div>
            <p
              className="text-right text-[min(3vw,55px)] max-sm:text-[min(5vw,70px)] "
              style={{
                textShadow: "2px 2px 5px white",
              }}
            >
              YUNG MEN
            </p>
          </div>
        </div>
      </div>
      <BouncingDiv size={50}>
        <YMLogo size={50} />
      </BouncingDiv>
    </div>
  );
}
